import emailjs from 'emailjs-com';

console.log('🛠️ reservation.js loaded');         // (1)
document.addEventListener('DOMContentLoaded', () => {
  console.log('📑 DOM ready');                   // (2)

  const btn = document.getElementById('reservationBtn');
  console.log('➤ BTN:', btn);                    // (3)

  if (!btn) return;  // don’t crash if missing

  emailjs.init('w6wXvynoq_8NlbRQc');

  btn.addEventListener('click', async () => {
    console.log('✉️ button clicked');            // (4)

    const form   = document.getElementById('reservation-form');
    const date   = form.date.value;
    const time   = form.time.value;
    const name   = form.user_name.value;
    const guests = form.guests.value;
    const phone  = form.user_phone.value;
    const email_sender  = form.user_email.value;
    const email_reciever = 'lucachef79@icloud.com'
    // const email_reciever = 'gjokangel@gmail.com'
    
    const subject = `Richiesta di prenotazione per ${date} alle ${time}`;
    const body    = 
      `Gentile staff,%0D%0A%0D%0Adesidero riservare un tavolo per ${date} alle ${time}, a nome di ${name}, per ${guests} persone.%0D%0A` +
      `Potete contattarmi al ${phone} oppure via email a ${emailSender}.%0D%0A%0D%0AResto in attesa di un vostro cortese riscontro.%0D%0A%0D%0ACordiali saluti,%0D%0A${name}`;

    // console.log({ date, time, name, guests, phone, email });

    try {
      await emailjs.send('service_ks58hgd','template_e12cpjb',{
        subject: `Richiesta di quotazione per ${date} alle ${time}`,
        date,
        time,
        user_name: name,
        guests,
        user_phone: phone,
    
        // ← Add this line so {{email}} isn’t empty
        email: email_reciever,
    
        // You can still keep user_email if you reference it in the body,
        // but the “To Email” binding needs the key `email`
        user_email: email_sender   
      });
      alert('Prenotazione inviata! Grazie.');
      form.reset();
    } catch(err) {
      console.error('EmailJS error:', err);
      window.location.href =
      `mailto:${email_reciever}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${body}`;
    }
  });
});
